import b from 'b_';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './icon.scss';

export const Icon = ({ hidden, ico, mix, mods = {}, theme, children, ...props }) => {
    const className = b('icon', ico, { hidden, theme, ...mods });

    return (
        <i className={cx('icon', className, mix)} {...props}>
            {children}
        </i>
    );
};

Icon.propTypes = {
    children: PropTypes.node,
    hidden: PropTypes.bool,
    ico: PropTypes.string.isRequired,
    mix: PropTypes.string,
    mods: PropTypes.object,
    theme: PropTypes.string,
};

export default Icon;
